import React from 'react';
import { useTranslation } from 'react-i18next';

const getTranslatedCategoryName = (categoryName: string) => {
    const { t, i18n } = useTranslation('translations', { keyPrefix: 'categoryName' });

    return categoryName
        .split('#')
        .filter(Boolean)
        .map(segment => {
            return i18n.exists(`translations:categoryName.${segment}`) ? t(segment) : segment;
        })
        .join('');
};

export default ({ categoryName }: { categoryName: string }) => (
    <>{getTranslatedCategoryName(categoryName)}</>
);
